<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Limit Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Limit Config</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWLimitConfigList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Trx Activity Type</strong> {{
                      !_.isEmpty(value.ewtrxactivitytype_trx_activity_type_id) ? value.ewtrxactivitytype_trx_activity_type_id.activity_type : 'NA'
                    }}
                  </li>

                  <li><strong>Frequency</strong> {{ !_.isEmpty(value.frequencies) ? value.frequencies.title : 'NA' }}
                  </li>
                  <li><strong>Max Trx Count</strong> {{ value.max_trx_count }}</li>
                  <li><strong>Max Trx Amount</strong> {{ value.max_trx_amount }}</li>
                  <li><strong>Status</strong>
                    {{ !_.isEmpty(value.status) ? value.status.charAt(0).toUpperCase() + value.status.slice(1) : 'NA' }}
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import axios from 'axios'
import {Notification} from 'element-ui'

const fileDownload = require("js-file-download")


export default {
  name: 'EWLimitConfigShow',
  metaInfo: {
    title: 'Limit Config | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {
      trx_activity_type: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    trxActivityTypeOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            console.log('error ' + error)
            resolve(error)
          })
      })
    },

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      await this.trxActivityTypeOptions().then(trx_activity_type => {
        this.pre.trx_activity_type = trx_activity_type
      })


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      });

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios.get(this.API_ASSET_UPLOAD_URL + url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({title: 'Download Failed', message: 'Failed to download', type: 'error'})
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/ew_limit_configs/' + id;
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {
          });
      })
    },
  },
}
</script>
